import { TItem } from '@modules/items';
import { TDocument } from '@modules/documents';
import { TReplica } from '@modules/replicas';
import { TInlineBlock } from '@modules/inlineBlocks';
import { TFile } from '../types';

const isTFile = (item: TDocument | TFile | TItem | TReplica | TInlineBlock | undefined): item is TFile =>
  Boolean(item && (item as TFile).type === 'FILE');

export default isTFile;
